import * as d3 from 'd3';

export const wrap = textString => {

  textString.each(function () {
    let text = d3.select(this);
    const maxWidth = text.attr("font-size") * 8 // 6.5; // scale max width by font size

    let words = text.text().split(/\s+/).reverse(); // create an array of the words in the text string, in reverse order
    let word;
    let line = [];
    let lineNumber = 0;
    const lineHeight = 1.1; // ems
    let firstLine = true;

    let tspan = text.text(null)
      .append("tspan");

    //keep removing words from the end of the remaining string until it fits
    while (words.length > 0 && lineNumber < 6) { // limit to maximum of 5 lines
      word = words.pop()// get an item from end of "words" array, and remove it from that array

      // if word is hyphenated, split it at hyphen
      /*
      if(word.indexOf("-") > 0) // string has "-"" after the first character
      {
        const parts = word.split("-");
        const lastPart = word.slice(parts[0].length); // the part of the word at and after the '-'
        words.push(lastPart); // put last part - back onto end of array
        word = parts[0];
      }
      */
      line.push(word); // add "word" removed from end of "words" to end of "line" array

      let newText = line.join(" "); // build a text string with spaces between 'words'
      newText = newText.replace(" -","-"); // if text has a hyphen, remove space before it
      tspan.text(newText);

      if (tspan.node().getComputedTextLength() > maxWidth) { // tspan line is still too long
        line.pop(); // remove an item from the end of the "line" array
        tspan.text(line.join(" "));
        line = [word];

        if (firstLine === false) { // this is not the first line, and it does not fit
          tspan = text.append("tspan")
            .attr("x", 0)
            .attr("dy", ++lineNumber * lineHeight + "em")
            .text(word);

        } else { // this is the first line and it does not fit
          text.selectAll("tspan")
            .text(word)
          firstLine = false;
        }
      } else { // tspan line fits OK, so no need to change it
        firstLine = false;
      }
    }

    // vertically centre the labels
    // let textHeight = (lineNumber - 0.7) * lineHeight;
    // let yOffset = -0.35 * textHeight;

    let textHeight = lineNumber * lineHeight;
    let yOffset = -0.32 * textHeight;

    // position first line just below icon
    // let yOffset = -lineHeight * 0.8;
    text.selectAll("tspan")
      .attr("y", yOffset + "em");

    return lineNumber + 1;
  });
}
